<template>
  <div class="page-container has-action">
    <van-nav-bar
      left-arrow
      :title="$route.params.id ? '编辑收货地址' : '新建收货地址'"
      @click-left="goableBack()"></van-nav-bar>
    <div class="page">
      <div class="bg-color-white">
        <van-field
          v-model="form.fields.custName"
          clearable
          label="收货人"
          maxlength="10"
          placeholder="请填写收货人姓名" />
        <van-field
          v-model="form.fields.phone"
          clearable
          label="手机号码"
          type="number"
          maxlength="11"
          placeholder="+86   请填写收货人手机号" />
        <van-field
          v-model="pickerRegion.text"
          readonly
          label="所在地区"
          placeholder="省市区县、乡镇等"
          @click="pickerRegion.show = true" />
        <van-field
          v-model="form.fields.detailAddress"
          type="textarea"
          label="详细地址"
          maxlength="50"
          autosize
          clearable
          placeholder="街道、楼牌号等" />
        <div class="mt-15 switch-bg">
          <van-switch-cell
            class="switch-btn"
            v-model="form.fields.isShowDefault"
            active-color="rgb(252, 134, 8)"
            inactive-color="rgb(234, 234, 234)"
            title="设为默认地址" />
          <div class="switch-tips">下单会优先使用该地址</div>
        </div>
      </div>
    </div>
    <div class="page-action px-20">
      <van-button
        class="save-btn"
        type="danger"
        block
        size="large"
        @click="onSubmit"
        >保存</van-button
      >
      <van-button
        class="mt-20 delete-btn"
        v-if="$route.params.id"
        type="danger"
        size="large"
        block
        plain
        @click="onDel"
        >删除</van-button
      >
    </div>
    <van-popup v-model="pickerRegion.show" position="bottom">
      <van-picker
        v-if="pickerRegion.pageShow"
        ref="pickerRegion"
        value-key="areaName"
        show-toolbar
        :loading="pickerRegion.loading"
        :columns="pickerRegion.columns"
        @cancel="pickerRegion.show = false"
        @confirm="onRegionConfirm"
        @change="onRegionChange" />
    </van-popup>
  </div>
</template>

<script>
import { Field, SwitchCell, Popup, Picker, Toast, Dialog } from "vant"
import * as validate from "@/utils/validate"
import * as CustApi from "@/api/cust"
import { mapActions } from "vuex"
export default {
  name: "edit",
  data: () => ({
    pickerRegion: {
      show: false,
      loading: false,
      pageShow: false,
      columns: [
        { values: [], className: "column1" },
        { values: [], className: "column2", defaultIndex: 0 },
        { values: [], className: "column3", defaultIndex: 0 }
      ],
      text: ""
    },

    form: {
      fields: {
        id: "",
        custName: "",
        phone: "",
        area: "",
        detailAddress: "",
        isShowDefault: false,
        isDefault: 1
      }
    },
    regionList: [],
    cityDates: {}
  }),
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      CustApi.getMyAddress({ id: to.params.id })
        .then((data) => {
          next((vm) => {
            vm.setData(data)
          })
        })
        .catch((e) => {})
    } else {
      next()
    }
  },
  beforeMount() {
    CustApi.countryAreasList()
      .then((data) => {
        if (data) {
          data.unshift({
            areaId: "",
            areaName: "请选择",
            areasList: [
              {
                areaId: "",
                areaName: "请选择",
                areasList: [
                  {
                    areaId: "",
                    areaName: "请选择",
                    areasList: [],
                    parentId: "",
                    areaType: 2
                  }
                ],
                parentId: "",
                areaType: 1
              }
            ],
            parentId: "",
            areaType: 0
          })
        }
        this.regionList = data
        this.pickerRegion.columns[0].values = Object.values(data).map(function (
          e
        ) {
          return { areaName: e.areaName, code: e.areaId }
        })
        this.pickerRegion.columns[1].values = Object.values(
          data[0].areasList
        ).map(function (e) {
          return { areaName: e.areaName, code: e.areaId }
        })
        this.pickerRegion.columns[2].values = Object.values(
          data[0].areasList[0].areasList
        ).map(function (e) {
          return { areaName: e.areaName, code: e.areaId }
        })
        this.$nextTick(function () {
          this.pickerRegion.pageShow = true
        })
      })
      .catch((e) => {
        this.$toast(e.msg || e.message)
      })
  },
  mounted() {},
  methods: {
    ...mapActions(["getUserInfo"]),
    setData(data) {
      this.form.fields.id = data.id
      this.form.fields.custName = data.custName
      this.form.fields.detailAddress = data.detailAddress
      this.form.fields.phone = data.phone
      this.form.fields.isDefault = data.isDefault
      this.form.fields.isShowDefault = data.isDefault == 0
      this.pickerRegion.text = data.area
      this.form.fields.area = data.area
    },
    onRegionChange(picker, values, index) {
      if (index == 0) {
        this.form.fields.provinceId = values[index].code
        picker.setColumnValues(
          1,
          this.cityData(this.regionList, values[0].areaName)
        )
      } else if (index == 1) {
        this.form.fields.areaId = values[index].code
        picker.setColumnValues(2, this.countryData(values[1].areaName))
      } else if (index == 2) {
        this.form.fields.cityId = values[index].code
      }
    },
    cityData(data, province) {
      data.forEach((item) => {
        if (item.areaName == province) {
          if (item.areasList[0].areaName != "请选择") {
            item.areasList.unshift({
              areaId: "",
              areaName: "请选择",
              areasList: [],
              parentId: "",
              areaType: 1
            })
          }
          this.cityDates = item
        }
      })
      return this.cityDates.areasList.map(function (res) {
        return { areaName: res.areaName, code: res.areaId }
      })
    },
    countryData(city) {
      let countryDatas = {}
      this.cityDates.areasList.forEach((item) => {
        if (item.areaName == city) {
          if (!item.areasList) {
            item.areasList = [
              {
                areaId: "",
                areaName: "请选择",
                areasList: [],
                parentId: "",
                areaType: 2
              }
            ]
          } else if (
            item.areasList.length == 0 ||
            item.areasList[0].areaName != "请选择"
          ) {
            item.areasList.unshift({
              areaId: "",
              areaName: "请选择",
              areasList: [],
              parentId: "",
              areaType: 2
            })
          }
          countryDatas = item
        }
      })
      if (!countryDatas) {
        countryDatas = this.cityDates.areasList[0]
      }
      return countryDatas.areasList.map(function (res) {
        return { areaName: res.areaName, code: res.areaId }
      })
    },
    onRegionConfirm(values, index) {
      if (values.some((n) => n.code == "")) {
        Toast("请选择地区")
        return
      }
      this.pickerRegion.text = `${values[0].areaName} ${values[1].areaName} ${values[2].areaName}`
      this.form.fields.area = this.pickerRegion.text
      this.pickerRegion.show = false
    },
    onSubmit() {
      if (this.form.fields.custName.length < 1) {
        Toast("请输入收货人姓名")
        return
      }
      if (this.form.fields.phone.length < 1) {
        Toast("请输入收货人手机号")
        return
      } else if (!validate.mobile(this.form.fields.phone)) {
        // else if (!/^\d+$/.test(this.form.fields.phone)) {
        Toast("收货人手机号格式不对")
        return
      }
      if (this.form.fields.area.length < 1) {
        Toast("请选择所在地区")
        return
      }
      // if (this.form.fields.detailAddress.length < 1) {
      //   Toast("请输入详细地址")
      //   return
      // }
      this.form.fields.isDefault =
        this.form.fields.isShowDefault == true ? 0 : 1
      this._showLoading()
      if (this.form.fields.id) {
        CustApi.editMyAddress(this.form.fields)
          .then((data) => {
            this._dismissLoading()
            this.getUserInfo()
            Toast({
              type: "success",
              message: "修改成功",
              onClose: () => {
                if (this.$route.query.redirect) {
                  this.$router.replace({ name: this.$route.query.redirect })
                } else {
                  this.goableBack()
                }
              }
            })
          })
          .catch((e) => {
            this._dismissLoading()
            this.$toast(e.msg || e.message)
          })
      } else {
        if (!this.$route.params.isNoEmpty) {
          this.form.fields.isDefault = 0
        }
        CustApi.addMyAddress(this.form.fields)
          .then((data) => {
            this._dismissLoading()
            this.getUserInfo()
            Toast({
              type: "success",
              message: "保存成功",
              onClose: () => {
                if (this.$route.query.redirect) {
                  this.$router.replace({
                    name: this.$route.query.redirect,
                    query: { addressId: data }
                  })
                } else {
                  //this.$router.replace({name:"address"});
                  this.goableBack()
                }
              }
            })
          })
          .catch((e) => {
            this._dismissLoading()
            console.info(e)
            this.$toast(e.msg || e.message)
          })
      }
    },
    onDel() {
      Dialog.confirm({
        message: "确定删除该地址吗？"
      }).then(() => {
        CustApi.deleteMyAddress(this.form.fields.id)
          .then((data) => {
            this.getUserInfo()
            console.info(0)
            Toast({
              type: "success",
              message: "删除成功",
              onClose: () => {
                if (this.$route.query.redirect) {
                  this.$router.replace({ name: this.$route.query.redirect })
                } else {
                  //this.$router.replace({name:"address"});
                  this.goableBack()
                }
              }
            })
          })
          .catch((e) => {
            console.error(e)
            this.$toast(e.msg || e.message)
          })
      })
    }
  },
  components: {
    [Field.name]: Field,
    [SwitchCell.name]: SwitchCell,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  }
}
</script>

<style lang="less" scoped>
.page-container {
  padding-top: 0;

  .page {
    margin: 20px;
    .bg-color-white {
      border-radius: 10px;
      .van-cell {
        background-color: transparent;
      }
      /deep/.van-cell__title {
        color: rgb(75, 75, 75);
        font-size: 16px;
        font-weight: 700;
      }
      .switch-bg {
        .switch-btn /deep/.van-cell__title {
          color: rgb(121, 121, 121);
        }
        .van-cell:not(:last-child)::after {
          border: none;
        }
        .switch-tips {
          color: rgb(121, 121, 121);
          font-size: 14px;
          margin: 0 15px;
          padding-bottom: 20px;
        }
      }
    }
  }

  .page-action {
    height: auto;
  }
  .save-btn {
    background-color: rgb(252, 134, 8);
    border: none;
    height: 34px;
    border-radius: 17px;
  }
  .delete-btn {
    border: none;
    color: rgb(252, 134, 8);
    height: 34px;
    border-radius: 17px;
    border: 1px solid rgb(252, 134, 8);
  }
}
</style>